export default "__VITE_ASSET__5a912d7e__"